<template>
  <div :class="['block', small, medium, focused, summary, isSelected]" id="version.id" v-if="block.type" @click="openBlock">
    <div class="box">
      <BlockMaterial :block="block" :medium="medium" :small="small"></BlockMaterial>
    </div>
    <div class="details">
      <h3 class="title" v-html="block.title">
      </h3>
      <h3 class="user">
        <span v-if="block.uploader">Added by {{ block.uploader }}</span>
      </h3>
    </div>
  </div>
</template>

<script>

import { db } from '@trust/firebase'
import { doc, updateDoc } from "firebase/firestore";

import { isSupported, setup } from "@loomhq/loom-sdk";
import { oembed } from "@loomhq/loom-embed";

const PUBLIC_APP_ID_SANDBOX = "8ba2b237-d638-4666-8ea4-6fa22c09e155";
//const PUBLIC_APP_ID = "6b71d547-5915-4d0d-97a5-d12129f458ad";

import BlockMaterial from '@trust/components/BlockMaterial.vue'

export default {
  name: 'Block',
  components: {
    BlockMaterial,
  },
  data() {
    return {
      startConnect: false,
      startCreate: false,
      newConceptName: null,
      connectedConcept: null,
      conceptNumber1: 'PS',
      conceptNumber2: this.padNumber(this.$store.state.org.concepts.length + 1),
      conceptNumber3: 'A',
    }
  },
  props: ['block', 'index', 'id', 'small', 'medium', 'summary', 'viewActions', 'inConceptId', 'isSelected'],
  computed: {
    newConceptNumber(){
      return this.conceptNumber1 + '-' + this.conceptNumber2 + '-' + this.conceptNumber3;
    },
    focused() {
      let focusedClass = 'focused';

      if(this.startConnect == true || this.startCreate == true) {
        return focusedClass;
      } else {
        return '';
      }
    },
    newConceptOrder(){
      return this.$store.state.org.concepts.length + 1;
    },
    channelUrl(){
      if(this.block.type == 'Channel') {
        return `https://www.are.na/channel/${this.block.slug}`;
      }
      return '';
    },
    shouldViewActions(){
      console.log(this.viewActions)
      if(this.viewActions != undefined) {
        return this.viewActions;
      } else {
        return true;
      }
    }
  },
  methods: {
    insertLoomEmbed(html) {
      const target = this.$el.querySelector(".loom-embed");
      if (target) {
        target.innerHTML = html;
      }
    },
    async setupLoom() {
      const { supported, error } = await isSupported();
      const recordButton = this.$el.querySelector('.loom-sdk-button');

      if (!supported) {
        console.warn(`Error setting up Loom: ${error}`);
        return;
      }

      // If we already have a loom video
      if(this.version.loomUrl != undefined){
        console.log('inserting loom embed')
        const { html } = await oembed(this.version.loomUrl, { width: 400 });
        this.insertLoomEmbed(html);
        recordButton.classList.add('hide');
        return;
      }

      const { configureButton } = await setup({
        publicAppId: PUBLIC_APP_ID_SANDBOX, // change when deploying
      });

      const sdkButton = configureButton({ element: recordButton });

      sdkButton.on("insert-click", async (video) => {
        this.saveLoomToVersion(video.sharedUrl);
      });
    },
    async saveLoomToVersion(loomUrl){
      const versionRef = doc(db, "paragonday-version-units", this.version.id);
      console.log(versionRef)

      await updateDoc(versionRef, {
        loomUrl: loomUrl
      });

      this.version.loomUrl = loomUrl;
    },
    removeBlock(){
      this.$store.commit('removeBlock', { blockId: this.block.id, conceptId: this.inConceptId });
    },
    openConnectForm(){
      this.startConnect = !this.startConnect;

      if(this.startConnect == true && this.startCreate == true) {
        this.startCreate = false;
      }
    },
    openCreateForm(){
      this.startCreate = !this.startCreate;

      if(this.startConnect == true && this.startCreate == true) {
        this.startConnect = false;
      }

      if(this.startCreate == true) {
        this.$nextTick(() => this.$refs.conceptNameInput.focus());
      }
    },
    createConcept(){
      console.log('about to connect block: ', this.block.id)

      console.log(this.newConceptNumber);

      this.$store.commit('createConcept', { block: this.block, name: this.newConceptName, number: this.newConceptNumber, order: this.newConceptOrder });

      this.startCreate = false;
      this.newConceptName = null;
      this.newConceptNumber = null;

      this.$store.commit('fetchConcepts');
    },
    connectToConcept(){
      console.log('about to connect block: ', this.block.id)

      this.$store.commit('connectToConcept', { blockId: this.block.id, conceptId: this.connectedConcept });

      this.startConnect = false;
      this.connectedConcept = null;

      this.$store.commit('fetchConcepts');
    },
    padNumber(num){
      let newNum = '00' + num;
      return newNum;
    },
    openBlock(){
      if(!this.summary) {
        this.$store.dispatch('routing/openBlock', { blockId: this.block.id, conceptId: this.inConceptId });
      }
    }
  },
  mounted () {
  }
}
</script>

<style>
  .block {
    width: 100%;
    position: relative;
    margin-top: 24px;
    box-sizing: border-box;
    transform-origin: center center;
    transition: var(--transition-base);
  }

  .block:hover {
    cursor: pointer;
  }

  /* .block:hover .box {
    transform: scale(1.04);
  } */

  .block.medium .box {
    height: 40vh;
  }

  .block.small p {
    font-size: 12px;
    line-height: 150%;
  }

  .block.summary {
    display: grid;
    grid-template-columns: 40px 1fr;
    grid-gap: 10px;
  }

  .block.summary p {
    font-size: 6px;
    line-height: 120%;
    padding: 2px;
  }

  .block.summary .box {
    width: 40px;
    max-height: 40px;
    overflow: hidden;
    border: none;
    display: flex;
    justify-content: center;
  }

  .block.summary .details,
  .block.summary .details .title,
  .block.summary .details .user {
    text-align: left;
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    color: var(--beige-700);
    display: flex;
    align-items: center;
  }

  .block.summary {
    border-bottom: var(--border-station);
    padding: 15px 10px;
    margin: 0;
    color: var(--beige-700);
    cursor: pointer;
  }

  .block.summary.is--selected {
    background: var(--beige-400);
  }

  .block.summary:last-child {
    border-bottom: none;
  }

  .block.summary:hover .details,
  .block.summary:hover .details .title,
  .block.summary:hover .details .user,
  .block.summary.is--selected .details,
  .block.summary.is--selected .details .title,
  .block.summary.is--selected .details .user {
    color: var(--beige-1000);
  }

  .block p {
    margin: 0;
    overflow-wrap: anywhere;
    overflow-y: scroll;
  }

  .block .title,
  .block .user {
    padding-top: 8px;
    color: var(--beige-450);
    font-size: 18px;
    font-weight: 400;
    text-align: left;
    width: 80%;
    box-sizing: border-box;
  }

  .block .actions {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .block .connect {
    padding: 4px 20px;
    margin-bottom: 8px;
    background: white;
    border-radius: 4px;
    opacity: 0;
    transform-origin: center center;
    transition: all 150ms ease-in-out;
    font-size: 12px;
    text-align: center;
    border: 1px solid black;
  }

  .block .details {
    position: relative;
  }

  .block .box {
    position: relative;
    border: 1px solid var(--beige-500);
    border-radius: 2px;
    transform-origin: center bottom;
    transition: var(--transition-base);
  }

  .block.focused .box {
    border: 1px solid teal;
  }

  .block .connectForm {
    box-sizing: border-box;
    padding: 16px;
    background: white;
    width: 100%;
    height: 100%;
    text-align: left;
  }

  .block .connectForm input {
    width: 100%;
    margin-bottom: 8px;
    box-sizing: border-box;
  }

  .block .connectForm button {
    width: 100%;
    text-align: center;
  }

  .block .concept-number-selects {
    display: grid;
    grid-template-columns: 1fr 8px 45px 8px 1fr;
    text-align: center;
    margin-bottom: 8px;
  }

  .block .user {
    opacity: 0;
    position: absolute;
    top: 2px;
  }

  /* .block:hover .title {
    opacity: 0;
  }

  .block:hover .user {
    opacity: 1;
  }

  .block:hover .connect {
    opacity: 0.7;
  }

  .block .connect:hover {
    opacity: 1;
    cursor: pointer;
  }

  .block .connect:active {
    transform: scale(0.8);
  } */


  /* Mobile Styling */
  @media (max-device-width: 600px) {
    .block.small .box {
      height: 40vh;
    }
  }

  @media screen and (max-device-width: 600px) and (orientation:landscape) {
    .block.medium .box {
      height: 40vh;
    }

    .block.small .box {
      height: 40vh;
    }
  }


</style>
